import {css} from "@emotion/css";

export const RaikoDivider = () => {
    return (
        <section
            className={css`
              width: 100%;
              height: 1px;
              background: var(--header-border-bottom-color);
            `}/>
    )
}